import React from 'react'
import getMarkup from './parser'

export //* Used for Automation Cloud and Studio Table => TemplateOne, columns >= 2
const formMobileTable = (data: any, columns: any, template: any, tableType: string) => {
  let allContent = []

  for (let i = 1; i < data.length; i++) {
    if (!Array.isArray(data[i])) return null
    let current = []
    let j = 1

    if (data[i].length === 1) {
      if (data[i][0].type === 'divider')
        current.push(
          <tr key={`${tableType}_divider-${i}`}>
            {new Array(columns - 1).fill(0).map((_, k) => (
              <td className="divider" colSpan={2} key={`${tableType}_col_divider-${k}`}></td>
            ))}
          </tr>
        )
      else if (data[i][0].type === 'subDivider')
        current.push(
          <tr key={`${tableType}_subdivider-${i}`}>
            {new Array(columns - 1).fill(0).map((_, k) => (
              <td className="subDivider" colSpan={2} key={`${tableType}_col_subdivider-${k}`}></td>
            ))}
          </tr>
        )

      allContent.push(current)
      continue
    }

    if (data[i].length !== columns) return null

    if (i === 1) {
      //* First row
      while (j < columns) {
        const slide = (
          <div className="Table__Slide" key={`${tableType}-slide-${i}-${j}`}>
            &lt; slide &gt;
          </div>
        )
        current.push(
          getMarkup(data[i][j], template, i, j, tableType + '_first-row', slide, { colSpan: 2 })
        )
        j++
      }
    } else if (data[i][0] && data[i][0].outerClassName === 'Table__Subheading') {
      //* subheading
      while (j < columns) {
        current.push(
          getMarkup(data[i][0], template, i, j, tableType + '_subheading', null, {
            colSpan: 2,
          })
        )

        j++
      }
    } else {
      while (j < columns) {
        current.push(
          getMarkup(data[i][0], template, i, j, tableType + '_subheading-left', null, {
            colSpan: 1,
          }),
          getMarkup(data[i][j], template, i, j, tableType + '_subheading-right', null, {
            colSpan: 1,
          })
        )

        j++
      }
    }

    allContent.push(<tr key={`${template}-${tableType}-row-${i}`}>{current}</tr>)
  }

  return (
    <div className="Table__Mobile">
      <table>
        <thead>{allContent[0]}</thead>
        <tbody>{allContent.slice(1)}</tbody>
      </table>
    </div>
  )
}

export const formDesktopTable = (data: any, columns: any, template: any, tableType: string) => {
  let content = []

  for (let i = 1; i < data.length; i++) {
    if (!Array.isArray(data[i])) return null

    if (data[i].length === 1) {
      if (data[i][0].type === 'divider') {
        content.push(
          <tr key={`${tableType}_divider-${i}`}>
            <td className="divider"></td>
          </tr>
        )
      } else if (data[i][0].type === 'subDivider') {
        content.push(
          <tr key={`${tableType}_subdivider-${i}`}>
            <td className="subDivider"></td>
          </tr>
        )
      }

      continue
    }

    if (data[i].length !== columns) return null
    let current = []

    for (let j = 0; j < data[i].length; j++) {
      current.push(getMarkup(data[i][j], template, i, j, tableType))
    }

    content.push(<tr key={`${tableType}_row-${i}`}>{current}</tr>)
  }

  return (
    <table className="Table__Desktop">
      <thead>{content[0]}</thead>
      <tbody>{content.slice(1)}</tbody>
    </table>
  )
}
